// This "type definition" import comment provides auto-complete, go-to-def, etc.
// for Ember's internals throughout your application, so don't remove it!
/**
  @typedef {import('ember-source/types')} Types
*/
import 'core-js/es/array/to-reversed';
import 'core-js/es/array/to-sorted';
import '@glint/environment-ember-loose';
import '@glint/environment-ember-template-imports';
import Ember from 'ember';

import { importSync, isDevelopingApp, macroCondition } from '@embroider/macros';

if (macroCondition(isDevelopingApp())) {
  importSync('cpc-license-manager/deprecation-workflow');

  // ember-inspector compatibility with embroider
  const glimmerRuntime = importSync('@glimmer/runtime');
  glimmerRuntime.NewElementBuilder = glimmerRuntime.NewTreeBuilder;
  const glimmerTracking = importSync('@glimmer/tracking');
  const glimmerValidator = importSync('@glimmer/validator');
  const glimmerReference = importSync('@glimmer/reference');
  const glimmerDestroyable = importSync('@glimmer/destroyable');
  globalThis.define('@glimmer/runtime', () => glimmerRuntime);
  globalThis.define('@glimmer/tracking', () => glimmerTracking);
  globalThis.define('@glimmer/validator', () => glimmerValidator);
  globalThis.define('@glimmer/reference', () => glimmerReference);
  globalThis.define('@glimmer/destroyable', () => glimmerDestroyable);

  const { RSVP } = importSync('@ember/-internals/runtime');
  globalThis.define('rsvp', () => RSVP);
  globalThis.define('ember', () => ({ default: Ember }));
}

import Resolver from 'ember-resolver';
import loadInitializers from 'ember-load-initializers';
import config from 'cpc-license-manager/config/environment';
import 'cpc-license-manager/extensions/ember-data';
import 'cpc-license-manager/extensions/ember';
import 'cpc-license-manager/extensions/moment';
import 'bootstrap';
import Application from '@ember/application';
import '@warp-drive/ember/install';
import 'cpc-license-manager/assets/styles.scss';

export default class App extends Application {
  name = 'cpc-license-manager';
  modulePrefix = config.modulePrefix;
  podModulePrefix = config.podModulePrefix;
  Resolver = Resolver;
}

loadInitializers(App, config.modulePrefix);
